<template>
    <div class="add-class-wrapper">
        <TitleBaseBox :title="title" @close="close" @cancel="cancelClick" @confirm="confirmClick">
            <div class="content">
                <div class="input-wrapper">
                    <input :placeholder="palceHolder" v-model="className" />
                    <p class="error-tip" v-show="showTips">{{ errorTip }}</p>
                    <DeleteIcon class="input-delete-icon" @iconClick="iconClick" v-show="showIcon" />
                </div>
            </div>
        </TitleBaseBox>
    </div>
</template>

<script>
import DeleteIcon from "@/views/zhiji/bComponents/icons/DeleteIcon";
import TitleBaseBox from "@/views/zhiji/bComponents/TitleBaseBox";
import { filterTreeData } from "@/views/zhiji/js/common/util.js";

export default {
    name: "AddClassifyMaterial",
    props: ["data"],
    components: {
        TitleBaseBox,
        DeleteIcon
    },
    data() {
        return {
            className: "",
            showTips: false,
            treeData: this.getStorePorp("treeData").children
        };
    },
    computed: {
        palceHolder() {
            return this.$t("zhiji.knowlege.classifyHolder");
        },
        errorTip() {
            return this.$t("zhiji.knowlege.classifyErrTip");
        },
        confirmLabel() {
            return this.$t("zhiji.common.confirm");
        },
        cancelLabel() {
            return this.$t("zhiji.common.cancel");
        },
        title() {
            const upperNumber = {
                0: this.$t("zhiji.category.first"),
                1: this.$t("zhiji.category.second"),
                2: this.$t("zhiji.category.third")
            };
            let arr = this.data.path ? this.data.path.split("/") : [];
            return upperNumber[arr.length];
        },
        showIcon() {
            return this.className != "";
        }
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.materialLibraryPage[propName];
        },
        iconClick() {
            this.className = "";
        },
        cancelClick() {
            this.close();
        },
        confirmClick() {
            let arr = this.data.path.split("/");
            let treeData = {
                classId: this.data.path ? arr[arr.length - 1] : this.data.path,
                label: this.className,
                setLevel: this.data.isRoot ? 1 : arr.length + 1,
                type: this.data.type,
            };
            let checkData = filterTreeData(this.treeData, this.className);
            let isExist = checkData.some(item => item == this.className);
            if (isExist) {
                this.showTips = true;
                return true;
            } else {
                this.$store.dispatch("zhiji/addMaterialTagTrees", treeData);
                this.close();
                this.showTips = false;
            }
        },
        close() {
            this.$emit("closeModal");
        }
    }
};
</script>

<style lang="less" scoped>
.add-class-wrapper {
    height: 100%;
    width: 100%;
    background: rgba(65, 71, 94, 0.4);
    display: flex;
    align-items: center;
    justify-content: space-around;
    .input-wrapper {
        position: relative;
        input {
            width: 348px;
            padding: 9px 9px 10px;
            box-sizing: border-box;
            color: #41475e;
            border: 1px solid #d8e4f0;
            border-radius: 4px;
            padding-right: 35px;
            font-size: 12px;
        }
        .error-tip {
            position: absolute;
            color: #fe0931;
            margin-top: 2px;
        }
        .input-delete-icon {
            position: absolute;
            right: 8px;
            top: 50%;
            margin-top: -9px;
        }
    }
    .content {
        padding: 20px 5px 0;
        margin-bottom: 12px;
    }
}
</style>
